module.exports = __webpack_public_path__ + "assets/img/img-yinyue-5cd67825.jpg";